import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

import { ChartLoader } from '@/components/ui/ChartLoader';

export const InvoicesSkeleton = () => (
    <>
        <div className='display-flex'>
            <div className='display-flex flex-basis-33pct' />
            <div className='display-flex flex-basis-33pct'>
                <div className='display-flex width-100pct flex-column align-items-center gap-10 padding-25'>
                    <ContentLoader height={30} width={300} />
                    <ContentLoader height={30} width={200} />
                    <ContentLoader width={150} />
                </div>
            </div>
            <div className='display-flex flex-basis-33pct justify-content-end'>
                <div className='display-flex flex-column padding-10 margin-top-5'>
                    <ContentLoader height={32} width={130} />
                </div>
            </div>
        </div>
        <div className='margin-top-10 margin-bottom-50' style={{ marginLeft: '80px', marginRight: '80px' }}>
            <ChartLoader />
        </div>
    </>
);
